<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 101.03 54.403"
  >
    <defs />
    <g transform="translate(.449)">
      <ellipse
        cx="49.12"
        cy="3.252"
        fill="#f2f2f2"
        rx="49.12"
        ry="3.252"
        transform="translate(1.224 47.899)"
      />
      <path
        fill="#2f2e41"
        d="M48.462 15.552c-8 0-13.749 5.135-13.749 17.115 0 13.578 5.746 17.172 13.749 17.172s14.091-3.936 14.091-17.172c.001-14.148-6.088-17.115-14.091-17.115zm.053 29.78c-5.543 0-8.439-3.252-8.439-12.656 0-8.3 3.014-12.674 8.558-12.674s8.558 2.874 8.558 12.674c0 9.167-3.133 12.656-8.676 12.656z"
      />
      <path
        class="fill-current text-primary"
        d="M29.921 40.369h-3.309v-9.744a1.951 1.951 0 00-1.951-1.951h-.775a1.951 1.951 0 00-1.951 1.951v9.744h-9.333a1.114 1.114 0 01-.985-1.634l9.878-18.7a1.951 1.951 0 00-.892-2.676l-.583-.275a1.951 1.951 0 00-2.554.845L5.418 40.467a2.646 2.646 0 00-.312 1.247 2.646 2.646 0 002.646 2.646h14.184v6.161a2.339 2.339 0 002.339 2.339 2.339 2.339 0 002.339-2.339V44.36h3.309a2 2 0 002-2 2 2 0 00-2-2zM91.193 40.369h-3.309v-9.744a1.951 1.951 0 00-1.951-1.951h-.775a1.951 1.951 0 00-1.951 1.951v9.744h-9.333a1.114 1.114 0 01-.985-1.634l9.878-18.7a1.951 1.951 0 00-.892-2.676l-.583-.275a1.951 1.951 0 00-2.554.845L66.69 40.467a2.646 2.646 0 00-.312 1.247 2.646 2.646 0 002.646 2.646h14.184v6.161a2.339 2.339 0 002.339 2.339 2.339 2.339 0 002.339-2.339V44.36h3.309a2 2 0 002-2 2 2 0 00-2-2z"
      />
      <path
        fill="none"
        stroke="#3f3d56"
        stroke-miterlimit="10"
        d="M30.833 39.228h-3.309v-9.744a1.951 1.951 0 00-1.951-1.951h-.775a1.951 1.951 0 00-1.951 1.951v9.744h-9.333a1.114 1.114 0 01-.985-1.634l9.878-18.7a1.951 1.951 0 00-.892-2.676l-.583-.275a1.951 1.951 0 00-2.554.845L6.33 39.326a2.646 2.646 0 00-.312 1.247h0a2.646 2.646 0 002.646 2.646h14.184v6.161a2.339 2.339 0 002.339 2.339h0a2.339 2.339 0 002.339-2.339v-6.161h3.309a2 2 0 002-2h0a2 2 0 00-2-2zM92.904 39.228h-3.309v-9.744a1.951 1.951 0 00-1.951-1.951h-.775a1.951 1.951 0 00-1.951 1.951v9.744h-9.333a1.114 1.114 0 01-.985-1.634l9.878-18.7a1.951 1.951 0 00-.892-2.676l-.583-.275a1.951 1.951 0 00-2.554.845L68.401 39.326a2.645 2.645 0 00-.312 1.247h0a2.646 2.646 0 002.646 2.646h14.184v6.161a2.339 2.339 0 002.339 2.339h0a2.339 2.339 0 002.339-2.339v-6.161h3.309a2 2 0 002-2h0a2 2 0 00-2.002-1.991zM50.288 14.525c-8 0-13.749 5.135-13.749 17.115 0 13.578 5.746 17.172 13.749 17.172s14.091-3.936 14.091-17.172c.001-14.148-6.088-17.115-14.091-17.115zm.053 29.78c-5.543 0-8.439-3.252-8.439-12.656 0-8.3 3.014-12.674 8.558-12.674s8.558 2.874 8.558 12.674c0 9.167-3.133 12.656-8.676 12.656z"
      />
      <circle
        cx="1.201"
        cy="1.201"
        r="1.201"
        fill="#2f2e41"
        transform="translate(42.671 .498)"
      />
      <ellipse
        cx="3.37"
        cy="4.366"
        fill="#2f2e41"
        rx="3.37"
        ry="4.366"
        transform="translate(43.433)"
      />
      <path
        d="M46.802 7.417c-1.688 0-3.086-1.608-3.331-3.707a5.68 5.68 0 00-.038.659c0 2.411 1.509 4.366 3.37 4.366s3.37-1.955 3.37-4.366a5.68 5.68 0 00-.038-.659c-.246 2.095-1.645 3.707-3.333 3.707z"
        opacity=".1"
      />
      <path
        fill="#3f3d56"
        d="M53.659 17.151a1.251 1.251 0 01-.73.7 6.45 6.45 0 01-2.492.489 4.2 4.2 0 01-.665-.012 1.912 1.912 0 01-1.141-.524.157.157 0 010-.265 4.38 4.38 0 012.013-1.044 7.706 7.706 0 012.262-.551c.627.059.845.835.753 1.207z"
      />
      <path
        d="M53.659 17.151a1.251 1.251 0 01-.73.7 6.45 6.45 0 01-2.492.489 4.2 4.2 0 01-.665-.012 1.912 1.912 0 01-1.141-.524.157.157 0 010-.265 4.38 4.38 0 012.013-1.044 7.706 7.706 0 012.262-.551c.627.059.845.835.753 1.207z"
        opacity=".1"
      />
      <path
        fill="#3f3d56"
        d="M44.422 14.929a1.841 1.841 0 00-.112 1.4 2.452 2.452 0 00.822 1.164 5.342 5.342 0 003.438.847 26.506 26.506 0 003.157-.216 3.774 3.774 0 001.024-.238 1.571 1.571 0 00.879-.887 1.081 1.081 0 00-.292-1.171 1.833 1.833 0 00-1.071-.293l-2.15-.129a3.647 3.647 0 01.754-.493 3.4 3.4 0 00.821-.869 12.009 12.009 0 011.251-1.287 1.847 1.847 0 00.623 1.008c.3.277.643.5.954.764.752.639 1.294 1.505 2.085 2.1a4.081 4.081 0 001.494-.746l-.307-.557a.367.367 0 00-.116-.145c-.087-.054-.2-.026-.3-.041-.27-.04-.388-.352-.494-.6a7.819 7.819 0 00-1.324-1.807 9.129 9.129 0 01-.931-1.371 4.691 4.691 0 00-.523-.838 1.18 1.18 0 00-.851-.445 1.639 1.639 0 00-.811.3 21.456 21.456 0 00-2.2 1.5 5.092 5.092 0 01-1.163.761c-.181.074-.372.124-.547.213a3.653 3.653 0 00-.785.658 5.219 5.219 0 01-3.325 1.418z"
      />
      <path
        fill="#f5a079"
        d="M48.918 8.949a2.214 2.214 0 01-.161.748.935.935 0 01-.537.519 1.152 1.152 0 01-.524.017 1.013 1.013 0 01-.427-.145.91.91 0 01-.339-.628c-.037-.242-.02-.489-.044-.732a4 4 0 00-.112-.582l-.048-.19c-.016-.063-.031-.127-.045-.19s-.025-.119-.035-.179-.016-.1-.022-.153a1.718 1.718 0 00-.075-.448 1.362 1.362 0 00-.157-.266c-.027-.038-.052-.076-.076-.116a.548.548 0 01-.091-.349.3.3 0 01.014-.056c0-.007 0-.014.008-.021a.168.168 0 00.115-.107.32.32 0 00-.014-.166 1.057 1.057 0 00-.089-.213c-.025-.045-.108-.125-.109-.176 0-.1.2-.185.28-.226a1.564 1.564 0 01.8-.162.59.59 0 01.467.215 1.411 1.411 0 01.114.463.136.136 0 00.028.062.125.125 0 00.069.032.423.423 0 00.132.005h.035a.462.462 0 00.189-.082q.054-.014.11-.024c.147.463.166.96.286 1.432a3.674 3.674 0 01.157.708v.265a.644.644 0 00.012.1 1.448 1.448 0 00.049.162c.006.017.011.034.015.052s.006.025.008.038a1.393 1.393 0 01.017.393z"
      />
      <circle
        cx="1.729"
        cy="1.729"
        r="1.729"
        fill="#fbbebe"
        transform="translate(45.133 2.461)"
      />
      <path
        fill="#fbbebe"
        d="M57.837 13.609a2.835 2.835 0 00-.488-1.313l.135.8a.3.3 0 01-.314-.1.962.962 0 01-.164-.305 6.282 6.282 0 00-.764-1.372 8.161 8.161 0 01-3.156-1.08c-.968-.532-1.874-1.169-2.829-1.723a4.057 4.057 0 00-.516-.264c-.3-.12-.634-.182-.918-.323l-.057-.03a1.17 1.17 0 01-.181-.122.959.959 0 01-.087-.08 1.9 1.9 0 01-.331-.554c-.152-.336-.206-.742-.358-1.079a1.043 1.043 0 01.233-.164l.037-.018a1.109 1.109 0 01.187-.068q.054-.015.11-.024a1.077 1.077 0 01.511.04 2.364 2.364 0 01.646.4 10.617 10.617 0 01.945.75c.167.16.319.336.5.481a3.923 3.923 0 00.471.312l2.916 1.737c.329.2.658.392.98.6.489.315.96.657 1.431 1l.832.6a.907.907 0 01.236.218.79.79 0 01.1.32 2.923 2.923 0 01-.107 1.361z"
      />
      <path
        fill="#bed5db"
        d="M49.346 10.249c-.117.523-.645.839-.922 1.3a2.587 2.587 0 00-.074 1.886l-.707.609c-.13.112-.26.224-.4.323a5.343 5.343 0 01-.639.367l-.626.322a2.99 2.99 0 01-.613.26 2.361 2.361 0 01-1.254-.091.568.568 0 01-.137-.056.222.222 0 01-.065-.059.364.364 0 01-.041-.236 11.113 11.113 0 01.375-2.02 5.953 5.953 0 01.863-2.116 6.361 6.361 0 01.738-1.072 1.721 1.721 0 00.342-.441 2.365 2.365 0 00.085-.768 1.6 1.6 0 01.152-.559 1.59 1.59 0 01.162-.268l.085.2.056.13.072.166.2.476a2.013 2.013 0 00.311.554.605.605 0 001.036-.079 1.98 1.98 0 00.212-.56 1.789 1.789 0 00.023-.73 8.623 8.623 0 00-.413-1.376 1.393 1.393 0 01-.1-.454.312.312 0 01.005-.052v-.013a1.109 1.109 0 01.187-.068q.055-.015.11-.024l.381 2.06.009.049c.018.1.037.2.057.3s.038.178.061.266c.008.03.016.059.024.089.023.081.048.161.076.24a2.726 2.726 0 01.369 1.445z"
      />
      <path
        fill="#3f3d56"
        d="M56.362 17.596a.613.613 0 00.057.293.7.7 0 00.592.261 17.542 17.542 0 003.936-.12.454.454 0 00.2-.062c.185-.13.071-.447-.131-.548a2.542 2.542 0 00-.664-.121 2.094 2.094 0 01-.622-.27q-.675-.388-1.331-.809a1.056 1.056 0 00-.86-.246 1.535 1.535 0 00-1.177 1.622z"
      />
      <path
        fill="#fbbebe"
        d="M46.689 7.728c0 .012 0 .024-.007.036s-.007.04-.011.06c-.036.186-.081.371-.132.555-.141.508-.329 1.009-.516 1.5l-1.505 3.965c-.127.333-.253.666-.4.992l-.147.329a4.578 4.578 0 00-.4 1.228 2.556 2.556 0 00-.018.842.864.864 0 00.487.649c.128.05.312.117.277.251a.2.2 0 01-.177.121.681.681 0 01-.556-.16c-.14-.125-.248-.318-.435-.339a.735.735 0 00-.367.117 2.218 2.218 0 01-1.553-.091.545.545 0 01.451-.382 3.65 3.65 0 01.626-.018.327.327 0 00.19-.049.345.345 0 00.1-.175 7.356 7.356 0 00.3-1.224c.067-.435.1-.876.192-1.305.075-.335.19-.659.289-.988a20.93 20.93 0 00.471-2.056 7.266 7.266 0 00.133-.872c.017-.243.009-.488.032-.73a5.674 5.674 0 01.2-.931l.269-1a3.347 3.347 0 01.612-1.382 1.3 1.3 0 01.934-.446.92.92 0 01.2.021l.032.008a.8.8 0 01.2.084c.1-.066.156-.043.225.059a.65.65 0 01.082.353 4.884 4.884 0 01-.078.978z"
      />
      <path
        fill="#6c63ff"
        d="M46.803 8.116l-.024.024-.236.235-.115-.485-.4-1.663a.92.92 0 01.2.021.3.3 0 01.014-.056l.019.064.134.457.254.867.042.143z"
      />
      <path
        fill="#2f2e41"
        d="M48.298 2.813a1.171 1.171 0 01-.345.828 1.143 1.143 0 01-.127.11 1.166 1.166 0 01-.7.235H45.72a1.1725 1.1725 0 110-2.345h1.406a1.176 1.176 0 011.172 1.172z"
      />
      <circle
        cx="1.201"
        cy="1.201"
        r="1.201"
        fill="#2f2e41"
        transform="translate(48.414 .498)"
      />
      <path
        d="M49.586.498h-.044a1.2 1.2 0 010 2.4h.044a1.2 1.2 0 100-2.4zM43.878.498h.044a1.2 1.2 0 000 2.4h-.044a1.2 1.2 0 010-2.4zM47.83 3.75a1.167 1.167 0 01-.7.235h-1.406a1.167 1.167 0 01-.7-.235z"
        opacity=".1"
      />
      <path
        fill="#fbbebe"
        d="M56.904 12.455s.3.873.58.64l-.221-1.141z"
      />
      <path
        fill="#57b894"
        d="M93.759 39.068a1.938 1.938 0 10.258-3.717l.048 1-.472-.855a1.931 1.931 0 00-.995 1.092 1.9 1.9 0 00-.111.524 1.938 1.938 0 001.272 1.956z"
      />
      <path
        fill="none"
        stroke="#3f3d56"
        stroke-miterlimit="10"
        d="M96.094 50.637c-.167-.848.555-1.6 1.268-2.089s1.546-.969 1.79-1.8c.35-1.192-.692-2.284-1.5-3.226a11.666 11.666 0 01-1.539-2.287 3.147 3.147 0 01-.368-1.04 3.588 3.588 0 01.277-1.558q.855-2.519 1.828-5"
      />
      <path
        fill="none"
        stroke="#3f3d56"
        stroke-miterlimit="10"
        d="M93.839 38.811a1.938 1.938 0 10.258-3.717l.048 1-.472-.855a1.931 1.931 0 00-.995 1.092 1.9 1.9 0 00-.111.524 1.938 1.938 0 001.272 1.956z"
      />
      <path
        fill="#57b894"
        d="M95.857 33.298a1.936 1.936 0 011.395-1.229l.16.948.3-1a1.938 1.938 0 11-1.85 1.277z"
      />
      <path
        fill="none"
        stroke="#3f3d56"
        stroke-miterlimit="10"
        d="M95.963 32.956a1.936 1.936 0 011.395-1.229l.16.948.3-1a1.938 1.938 0 11-1.85 1.277z"
      />
      <path
        fill="#57b894"
        d="M97.311 43.543a1.938 1.938 0 001.715-3.448l-.227.765-.161-.959h-.005a1.938 1.938 0 00-1.322 3.643z"
      />
      <path
        fill="none"
        stroke="#3f3d56"
        stroke-miterlimit="10"
        d="M97.404 43.196a1.938 1.938 0 001.715-3.448l-.227.765-.161-.96h-.005a1.938 1.938 0 00-1.322 3.643z"
      />
      <path
        fill="#57b894"
        d="M95.292 46.761a1.937 1.937 0 10.373-1.518l.864 1.3-1.18-.69a1.919 1.919 0 00-.057.908z"
      />
      <path
        fill="none"
        stroke="#3f3d56"
        stroke-miterlimit="10"
        d="M95.371 46.504a1.937 1.937 0 10.373-1.518l.864 1.3-1.18-.69a1.919 1.919 0 00-.057.908z"
      />
      <path
        fill="#57b894"
        d="M.839 43.789a1.273 1.273 0 10.17-2.442l.032.655-.31-.562a1.268 1.268 0 00-.654.717 1.248 1.248 0 00-.073.344 1.273 1.273 0 00.835 1.288z"
      />
      <path
        fill="none"
        stroke="#3f3d56"
        stroke-miterlimit="10"
        d="M2.372 51.39c-.109-.557.365-1.052.833-1.373s1.016-.637 1.176-1.182c.23-.783-.455-1.5-.987-2.119a7.666 7.666 0 01-1.011-1.5 2.068 2.068 0 01-.242-.683 2.358 2.358 0 01.182-1.024q.562-1.655 1.2-3.282"
      />
      <path
        fill="none"
        stroke="#3f3d56"
        stroke-miterlimit="10"
        d="M.891 43.621a1.273 1.273 0 10.17-2.442l.032.655-.31-.562a1.268 1.268 0 00-.654.717 1.248 1.248 0 00-.073.344 1.273 1.273 0 00.835 1.288z"
      />
      <path
        fill="#57b894"
        d="M2.218 39.998a1.272 1.272 0 01.916-.807l.1.623.194-.654a1.273 1.273 0 11-1.216.839z"
      />
      <path
        fill="none"
        stroke="#3f3d56"
        stroke-miterlimit="10"
        d="M2.288 39.774a1.272 1.272 0 01.916-.807l.1.623.194-.654a1.273 1.273 0 11-1.216.839z"
      />
      <path
        fill="#57b894"
        d="M3.172 46.729a1.273 1.273 0 001.127-2.265l-.149.5-.106-.63a1.27324978 1.27324978 0 10-.868 2.394z"
      />
      <path
        fill="none"
        stroke="#3f3d56"
        stroke-miterlimit="10"
        d="M3.232 46.502a1.273 1.273 0 001.127-2.265l-.149.5-.106-.63h0a1.27324978 1.27324978 0 10-.868 2.394z"
      />
      <path
        fill="#57b894"
        d="M1.846 48.844a1.273 1.273 0 10.245-1l.567.854-.775-.453a1.261 1.261 0 00-.037.599z"
      />
      <path
        fill="none"
        stroke="#3f3d56"
        stroke-miterlimit="10"
        d="M1.899 48.675a1.273 1.273 0 10.245-1l.567.854-.775-.453a1.261 1.261 0 00-.037.599z"
      />
      <ellipse
        cx="1.583"
        cy="2.049"
        fill="#2f2e41"
        rx="1.583"
        ry="2.049"
        transform="translate(43.203 27.667)"
      />
      <ellipse
        cx="1.583"
        cy="2.049"
        fill="#2f2e41"
        rx="1.583"
        ry="2.049"
        transform="translate(51.816 27.714)"
      />
      <path
        fill="#2f2e41"
        d="M52.188 35.815c0 .926-1.292 1.676-2.887 1.676s-2.887-.751-2.887-1.676c0-.8.969-1.472 2.265-1.636a4.66 4.66 0 01.622-.04 4.723 4.723 0 011.036.112c1.083.241 1.851.851 1.851 1.564z"
      />
      <ellipse
        cx="1.583"
        cy="2.049"
        fill="none"
        stroke="#3f3d56"
        stroke-miterlimit="10"
        rx="1.583"
        ry="2.049"
        transform="translate(43.575 27.202)"
      />
      <ellipse
        cx="1.583"
        cy="2.049"
        fill="none"
        stroke="#3f3d56"
        stroke-miterlimit="10"
        rx="1.583"
        ry="2.049"
        transform="translate(52.189 27.248)"
      />
      <ellipse
        cx="2.887"
        cy="1.676"
        fill="none"
        stroke="#3f3d56"
        stroke-miterlimit="10"
        rx="2.887"
        ry="1.676"
        transform="translate(46.788 33.673)"
      />
      <path
        fill="#fff"
        d="M50.373 34.392a.46.46 0 01-.123.316.4.4 0 01-.3.131h-.931a.434.434 0 01-.413-.447.457.457 0 01.076-.255 4.382 4.382 0 01.624-.045 4.439 4.439 0 011.036.119.472.472 0 01.031.181z"
      />
      <circle
        cx=".466"
        cy=".466"
        r=".466"
        fill="#fff"
        transform="translate(44.693 28.226)"
      />
      <circle
        cx=".466"
        cy=".466"
        r=".466"
        fill="#fff"
        transform="translate(53.353 28.226)"
      />
      <circle
        cx=".466"
        cy=".466"
        r=".466"
        fill="#6c63ff"
        opacity=".3"
        transform="translate(53.818 32.602)"
      />
      <circle
        cx=".466"
        cy=".466"
        r=".466"
        fill="#6c63ff"
        opacity=".3"
        transform="translate(42.458 32.602)"
      />
    </g>
  </svg>
</template>
